import React, { FC } from 'react'
import { EuiHeaderText } from './EuiHeaderText'

export interface Props {
  src: string
  brandName?: string
  href?: string
  target?: string
}

const HeaderLogo: FC<Props> = ({ src, brandName, href, target, ...rest }) => {
  return (
    <a
      rel="noreferrer"
      className="euiHeaderLogo"
      aria-label="Goes to landing page"
      href={href}
      target={target}
      {...rest}
    >
      <img
        alt=""
        src={src}
        aria-label="Brand Logo"
        style={{ height: '40px' }}
      />
      {brandName && (
        <>
          <EuiHeaderText
            iconSrc={
              // @ts-ignore
              window.REACT_APP_LOGO_URL
            }
            iconTitle={`${brandName} Logo`}
          >
            {brandName}
          </EuiHeaderText>
        </>
      )}
    </a>
  )
}

export default HeaderLogo
